//Common
import { STATUS_CORRECAO_SOLICITACAO } from "@/common/constantes";

//Util
import {
  MENSAGENS_AVISO,
  MENSAGENS_SUCESSO,
  showMensagemAviso,
  showMensagemSucesso,
  showMensagemErroApi,
} from "@/frontend/utils/mensagens";

//API
import api from "./api";

//Rotas de inclusão/alteração
export const ROTA_SALVAR = {
  TENANT: { CRIAR: "/tenant/criar", EDITAR: "/tenant/editar" },
  PERFIL: { CRIAR: "/perfil/criar", EDITAR: "/perfil/editar" },
  USUARIO: { CRIAR: "/usuario/criar", EDITAR: "/usuario/editar" },

  ACESSO_TELA_PEFIL: { SALVAR: "/acesso_tela_perfil/salvar" },
  AUTORIZACAO_PEFIL: { SALVAR: "/autorizacao_perfil/salvar" },

  PARAMETRIZACAO_TENANT: { SALVAR: "/parametrizacao_tenant/salvar" },

  LOG_ALTERACAO_PARAM: { SALVAR: "/log_alteracao_param/salvar" },

  NOTIFICACAO_TIPO_PEFIL: { SALVAR: "/notificacao_tipo_perfil/salvar" },
  NOTIFICACAO_USUARIO: { CRIAR: null, EDITAR: "/notificacao_usuario/editar" },

  FERIADO: { CRIAR: "/feriado/criar", EDITAR: "/feriado/editar" },

  PESSOA_CONTA_BANCARIA: {
    CRIAR: "/pessoa_conta_bancaria/criar",
    EDITAR: "/pessoa_conta_bancaria/editar",
  },

  EMPRESA: { CRIAR: "/empresa/criar", EDITAR: "/empresa/editar" },

  FILIAL: { CRIAR: "/filial/criar", EDITAR: "/filial/editar" },
  FILIAL_ATENDIMENTO: { SALVAR: "/filial_atendimento/salvar" },

  FORNECEDOR: {
    CRIAR: "/fornecedor/criar",
    EDITAR: "/fornecedor/editar",
  },

  SETOR: { CRIAR: "/setor/criar", EDITAR: "/setor/editar" },
  BANDEIRA: { CRIAR: "/bandeira/criar", EDITAR: "/bandeira/editar" },

  CENTRO_CUSTO: {
    CRIAR: "/centro_custo/criar",
    EDITAR: "/centro_custo/editar",
  },

  CENTRO_CUSTO_QTDE_COLAB: {
    SALVAR: "/centro_custo_qtde_colab/salvar",
  },

  CONTA_TENANT: {
    CRIAR: "/conta_tenant/criar",
    EDITAR: "/conta_tenant/editar",
  },

  AREA: { CRIAR: "/area/criar", EDITAR: "/area/editar" },

  ALCADA: {
    CRIAR: "/alcada/criar",
    EDITAR: "/alcada/editar",
  },

  PRODUTO_GRUPO: {
    CRIAR: "/produto_grupo/criar",
    EDITAR: "/produto_grupo/editar",
  },

  BANCO: {
    CRIAR: "/banco/criar",
    EDITAR: "/banco/editar",
  },

  IMPOSTO: {
    CRIAR: "/imposto/criar",
    EDITAR: "/imposto/editar",
  },

  FORMA_PAGAMENTO: {
    CRIAR: "/forma_pagamento/criar",
    EDITAR: "/forma_pagamento/editar",
  },

  TIPO_DOCUMENTO: {
    CRIAR: "/tipo_documento/criar",
    EDITAR: "/tipo_documento/editar",
  },

  INDICE_REAJUSTE: {
    CRIAR: "/indice_reajuste/criar",
    EDITAR: "/indice_reajuste/editar",
  },

  INDICE_REAJUSTE_PERC: { SALVAR: "/indice_reajuste_perc/salvar" },

  CONTA: {
    CRIAR: "/conta/criar",
    EDITAR: "/conta/editar",
  },
  CONTA_GRUPO: {
    CRIAR: "/conta_grupo/criar",
    EDITAR: "/conta_grupo/editar",
  },
  CONTA_NATUREZA: {
    CRIAR: "/conta_natureza/criar",
    EDITAR: "/conta_natureza/editar",
  },
  PLANO_CONTA: {
    CRIAR: "/plano_conta/criar",
    EDITAR: "/plano_conta/editar",
  },

  //Solicitação
  CAMPO_CONTRATO_CONTA_GRUPO: {
    SALVAR: "/campo_contrato_conta_grupo/salvar",
  },

  SOLICITACAO: { CRIAR: "/solicitacao/criar", EDITAR: "/solicitacao/editar" },
  SOLICITACAO_INF_ADIC: { EDITAR: "/solicitacao/atualizarInfAdicional" },

  SOLICITACAO_PAG: {
    CRIAR: null,
    EDITAR: "/solicitacao_pag/editar",
  },
  SOLICITACAO_PAG_CONFERENCIA: { CRIAR: "/solicitacao_pag_conferencia/criar" },

  //Importações
  IMPORTAR: {
    RESUMO_VENDA_GRUPO: "/resumo_venda_grupo/importar",
    RESUMO_VENDA_QTDE_CLIENTE: "/resumo_venda/importar",
    FORNECEDOR: "/fornecedor/importar",
    NOTA_FORNECEDOR: "/nota_entrada/importar",
    META_EMPRESA: "/meta_empresa/importar",
    QTDE_COLAB_CENTRO_CUSTO: "/centro_custo_qtde_colab/importar",
    //INDICE_REAJUSTE_PERC: "/indice_reajuste_perc/importar",
  },
};

//Rotas de exclusão
export const ROTA_EXCLUIR = {
  PERFIL: "/perfil/excluir",
  //USUARIO: "/usuario/excluir",

  //AREA: "/area/excluir",

  FERIADO: "/feriado/excluir",

  ALCADA: "/alcada/excluir",

  SOLICITACAO: "/solicitacao/excluir",
};

/* OBS.: ESSAS FUNÇÕES NÃO ENVIAM MENSAGEM DE ERRO SE O CODIGO DO ERRO FOR "401" - SESSÃO EXPIRADA
 *       POIS A SESSÃO EXPIRADA É TRATADA NO ARQUIVO API.JS, NA CONFIGURAÇÃO DO AXIOS,
 *       REDIRECIONANDO PARA UMA PÁGINA DE SESSÃO EXPIRDA
 */

//###################### ROTA SALVAR ######################//
export async function api_salvar(rotaSalvar, id, body, showMessage = true) {
  let ret = null;

  try {
    if (id) {
      //edição
      const { data } = await api.put(`${rotaSalvar.EDITAR}/${id}`, body);

      if (data) {
        ret = data;
      }

      if (showMessage) {
        showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
      }
    } else {
      //inclusão ou salvar (inc/alt/exc)
      const { data } = await api.post(
        `${rotaSalvar?.CRIAR || rotaSalvar?.SALVAR || rotaSalvar}`,
        body,
      );

      if (data) {
        ret = data;
      }

      if (showMessage) {
        showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
      }
    }
  } catch (error) {
    showMensagemErroApi(
      error,
      id ? "editar" : rotaSalvar.CRIAR ? "incluir" : "salvar",
    );
  }

  return ret;
}

export async function api_salvarFormData(
  rotaSalvar,
  id,
  formData,
  showMessage = true,
) {
  let ret = null;

  try {
    if (id) {
      // Edição
      const { data } = await api.put(`${rotaSalvar.EDITAR}/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      ret = data;
    } else {
      // Inclusão
      const { data } = await api.post(
        `${rotaSalvar.CRIAR ? rotaSalvar.CRIAR : rotaSalvar.SALVAR}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      ret = data;
    }

    if (showMessage) {
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(
      error,
      id ? "editar" : rotaSalvar.CRIAR ? "incluir" : "salvar",
    );
  }

  return ret;
}

/*
 * Exclui um registro do model ref. a rota passada como parâmetro
 * A rota é passada como parâmetro obtida nas constantes de ROTA_EXCLUIR
 * Ex: ROTA_EXCLUIR.PP_GRUPO, ROTA_EXCLUIR.PP_FAIXA_ID
 */
export async function api_excluir(rotaExcluir, id, params) {
  let result = 0;

  try {
    const { data } = await api.delete(`${rotaExcluir}/${id}`, {
      params: params,
    });

    if (data > 0) {
      result = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "excluir");
  }

  return result;
}

//###################### ROTAS ESPECÍFCIAS ######################//
/*
 * Salva a autorização se o usuário estiver liberado para autorizar determinada ação
 */
export async function api_autorizar(body) {
  let ret = null;

  try {
    body.id_tenant_consulta = body.id_tenant;

    const { data } = await api.post("/autorizacao/autorizar", body);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "autorizar");
  }

  return ret;
}

/*
 * Salva a data/hora do login do usuário
 */
export async function api_salvarLogin(idUsuario) {
  let ret = null;

  try {
    const { data } = await api.put(`/usuario/salvarLogin/${idUsuario}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "salvar login");
  }

  return ret;
}

/*
 * Altera a senha confirmando a senha atual
 */
export async function api_alterarSenha(
  idUsuario,
  senhaAtual,
  senha,
  primeiroAcesso,
) {
  let ret = null;

  try {
    const { data } = await api.put(`/usuario/alterarSenha/${idUsuario}`, {
      senha_atual: senhaAtual,
      senha: senha,
      primeiro_acesso: primeiroAcesso,
    });

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "alterar a senha");
  }

  return ret;
}

/*
 * Redefine a senha sem necessidade de informar a senha atual
 */
export async function api_redefinirSenha(
  idUsuario,
  senha,
  motivo,
  idAutorizacao,
  idUsuarioAutorizacao,
  tokenAutorizacao,
) {
  let ret = null;

  try {
    const { data } = await api.put(`/usuario/redefinirSenha/${idUsuario}`, {
      senha: senha,
      motivo: motivo,
      id_autorizacao: idAutorizacao,
      id_usuario_autorizacao: idUsuarioAutorizacao,
      token_autorizacao: tokenAutorizacao, //comprovante da autorização, conferido pelo servidor
    });

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "redefinir a senha");
  }

  return ret;
}

/*
 * Altera a situação do contrato
 */
export async function api_alterarSituacaoContrato(idSolicitacao, body) {
  let ret = null;

  try {
    const { data } = await api.put(
      `/solicitacao_contrato/alterarSituacao/${idSolicitacao}`,
      body,
    );
    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "alterar a situação do contrato");
  }

  return ret;
}

/*
 * Edita os campos e os anexos do contrato da solicitação
 */
export async function api_editarContrato(idSolicitacao, formData) {
  let ret = null;

  try {
    const { data } = await api.put(
      `/solicitacao_contrato/editarContrato/${idSolicitacao}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "editar o contrato");
  }

  return ret;
}

/*
 * Salva a avaliação da solicitação/pagamento (Aprova ou Rejeita)
 */
export async function api_avaliarSolicitacao(idAprovacao, body) {
  let ret;
  try {
    const { data } = await api.put(
      `/solicitacao_aprovacao/avaliarSolicitacao/${idAprovacao}`,
      body,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "salvar a avaliação");
  }

  return ret;
}

/*
 * Salva a posse do documento
 */
export async function api_salvarPosseDocumento(body) {
  let ret;
  try {
    const { data } = await api.post(
      `/solicitacao_pag/salvarPosseDocumento`,
      body,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "salvar a posse do documento");
  }

  return ret;
}

/*
 * Envia a solicitação de reajuste do contrato
 */
export async function api_enviarSolicitacaoReajuste(body) {
  let ret;
  try {
    const { data } = await api.post(
      `/solicitacao_reajuste/enviarSolicitacaoReajuste`,
      body,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "enviar a solicitação do reajuste");
  }

  return ret;
}

/*
 * Exclui o envio da solicitação de reajuste do contrato
 */
export async function api_excluirSolicitacaoReajuste(idReajuste) {
  let ret;

  try {
    const { data } = await api.delete(
      `/solicitacao_reajuste/excluirSolicitacaoReajuste/${idReajuste}`,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "excluir a solicitação do reajuste");
  }

  return ret;
}

/*
 * Exclui determinado anexo do pagamento da solicitação
 */
export async function api_excluirUploadAnexoPag(idAnexoPag, params) {
  let ret;

  try {
    const { data } = await api.delete(
      `/solicitacao_pag_anexo/excluirUpload/${idAnexoPag}`,
      {
        params: params,
        //data: body,
      },
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "excluir anexo pagamento");
  }

  return ret;
}

/*
 * Cancela a solicitação
 */
export async function api_cancelarSolicitacao(idSolicitacao, body) {
  let ret;

  try {
    const { data } = await api.put(
      `/solicitacao/cancelar/${idSolicitacao}`,
      body,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "cancelar a solicitação");
  }

  return ret;
}

/*
 * Cancela o pagamento da solicitação
 */
export async function api_cancelarPagamento(idSolicitacaoPag, body) {
  let ret;

  try {
    const { data } = await api.put(
      `/solicitacao_pag/cancelar/${idSolicitacaoPag}`,
      body,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "cancelar o pagamento");
  }

  return ret;
}

/*
 * Cancela a conferência do pagamento
 */
export async function api_cancelarConferenciaPagamento(idSolicitacaoPag, body) {
  let ret;

  try {
    const { data } = await api.put(
      `/solicitacao_pag_conferencia/cancelar/${idSolicitacaoPag}`,
      body,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "cancelar a conferência do pagamento");
  }

  return ret;
}

/*
 * Altera o mês/ano ref. dos pagamentos da solicitação
 */
export async function api_alterarMesAnoRef(body) {
  let ret;

  try {
    const { data } = await api.post("/solicitacao_pag/alterarMesAnoRef", body);

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "alterar mês/ano ref. dos pagamentos");
  }

  return ret;
}

/*
 * Altera informações da solicitação que já foi aprovada, com autorização
 * A princípio só a descrição.
 */
export async function api_alterarInfSolicitacaoAprovada(idSolicitacao, body) {
  let ret;

  try {
    const { data } = await api.put(
      `/solicitacao/alterarInfSolicitacaoAprovada/${idSolicitacao}`,
      body,
    );

    if (data) {
      ret = data;
      showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
    }
  } catch (error) {
    showMensagemErroApi(error, "alterar informação da solicitação");
  }

  return ret;
}

/*
 * Corrige a seleção de conta, centro e os rateios dos pagamentos não conferidos
 * Retorna o status da correção (STATUS_CORRECAO_SOLICITACAO): se nada foi alterado, apresenta o aviso e não grava
 * @body: Objeto com os dados ou FormData (campo "dados" e os arquivos dos anexos) quando a solicitação possui contrato
 */
export async function api_corrigirSolicitacao(idSolicitacao, body) {
  let ret;

  try {
    const { data } = await api.put(
      `/solicitacao/corrigirSolicitacao/${idSolicitacao}`,
      body,
      body instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : undefined,
    );

    if (data) {
      ret = data;

      //Se nada foi alterado na tela, o servidor não grava a correção
      if (data.status == STATUS_CORRECAO_SOLICITACAO.SEM_ALTERACAO) {
        showMensagemAviso(MENSAGENS_AVISO.NENHUMA_ALTERACAO_REALIZADA);
      } else {
        showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
      }
    }
  } catch (error) {
    showMensagemErroApi(error, "corrigir solicitação");
  }

  return ret;
}
